// Stripe configuration
// Replace with your actual Stripe keys when ready

// Vite uses import.meta.env instead of process.env
const getStripeKey = () => {
  // For Vite
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_STRIPE_PUBLIC_KEY || 'pk_test_your_key_here'
  }
  // Fallback
  return 'pk_test_your_key_here'
}

export const STRIPE_CONFIG = {
  // Live Stripe publishable key — set VITE_STRIPE_PUBLIC_KEY in .env file
  publicKey: getStripeKey(),

  // Price IDs from Stripe Dashboard → Products → Pricing
  // Replace placeholders with real price IDs before deploying
  prices: {
    monthly: 'price_1TcxFIFYoyR64sdfFTWJMQmj',  // $12/month
    yearly: 'price_1TcxHRFYoyR64sdfGoER8MhS',    // $72/year
  },

  // Product configuration
  products: {
    premium: {
      name: 'Garden Planner Solo',
      description: 'Unlimited gardens, all plants, AI assistant, and premium features',
      features: [
        'Unlimited garden designs',
        'Access to all 200+ plants',
        'Advanced AI companion planting',
        'Harvest tracking & reports',
        'Priority weather alerts',
        'Export to PDF/CSV',
        'Offline mode',
        'Priority support'
      ]
    }
  }
}

// Subscription plans display
export const SUBSCRIPTION_PLANS = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    period: 'forever',
    description: 'Perfect for getting started',
    features: [
      '3 gardens',
      '5 basic plants',
      'Basic calendar',
      'Community access'
    ],
    cta: 'Get Started',
    popular: false
  },
  {
    id: 'monthly',
    name: 'Garden Planner Solo',
    price: 12,
    period: 'month',
    description: 'Full access, billed monthly',
    features: [
      'Unlimited gardens',
      'All 200+ plants',
      'AI assistant',
      'Harvest tracking',
      'Weather alerts',
      'Export features',
      'Priority support'
    ],
    cta: 'Start Free Trial',
    popular: true,
    trialDays: 14
  },
  {
    id: 'yearly',
    name: 'Garden Planner Solo Annual',
    price: 72,
    period: 'year',
    description: 'Save $72 (50% off monthly)',
    features: [
      'Everything in Monthly',
      '6 months free vs monthly',
      'Same full feature set'
    ],
    cta: 'Get Annual',
    popular: false,
    trialDays: 14,
    savings: 72
  }
]

export default STRIPE_CONFIG
